module.exports = __webpack_public_path__ + "static/media/verticalRectangle_yellow.01fc62d2.svg";